import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { FOR_BANK_SECTIONS, FOR_BANK_SUB_SECTIONS } from 'constants/businessToolSections/forBank';
import { debounce } from 'lodash';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import {
  calculatePeriodValueBaseOnPreviousPeriod,
  convertToOpposite,
  PERIODS_OPERATION_TYPES,
  summarizeSubtractPeriodValues,
} from 'components/BusinessToolForm/utils/helpers';

import { observedFields } from '../../utils/form';

export const useGetLongTermInvestmentsCalculation = () => {
  const { setValue } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_BANK_SECTIONS.MARKETING_AND_SALES,
    FOR_BANK_SUB_SECTIONS.FOR_BANK_MARKETING_AND_SALES.SALES_PLAN,
  );

  const [longTermInvestmentsFiled] = observedFields.longTermInvestments.setCalculatedValueFieldNames;

  const getLongTermInvestmentsCalculationHandler = useMemo(
    () =>
      debounce((content) => {
        if (!canAccess) return;

        const [initialLongTermInvestments, investingActivitiesTable] = content;
        const investingActivitiesPeriodValues = convertToOpposite(investingActivitiesTable[1]);
        const proceedFromSaleInvestmentsPeriodValues = investingActivitiesTable.at(-2);

        const investmentResult = summarizeSubtractPeriodValues(
          [investingActivitiesPeriodValues, proceedFromSaleInvestmentsPeriodValues],
          PERIODS_OPERATION_TYPES.SUBTRACT,
        );

        const longTermInvestments = calculatePeriodValueBaseOnPreviousPeriod(
          investmentResult,
          initialLongTermInvestments,
        );

        setValue(longTermInvestmentsFiled, longTermInvestments);
      }, 500),

    [],
  );

  return getLongTermInvestmentsCalculationHandler;
};
